import type { ComponentType } from 'react';
import type { HostOptions, SurfaceRegistry } from './contracts';
const surfaceKey = (value: string) => String(value ?? '').trim();

/** Host-only registry. Core never sees concrete Surface names. */
export const createSurfaceRegistry = (entries: { [key: string]: ComponentType<HostOptions> } = {}): SurfaceRegistry => {
  const surfaces = new Map(Object.entries(entries).map(([key, Surface]) => [surfaceKey(key), Surface]));
  return Object.freeze({
    resolve: (key: string) => {
      const normalizedKey = surfaceKey(key);
      const Surface = surfaces.get(normalizedKey);
      if (typeof Surface !== 'function') throw new Error(`Unregistered chat surface: ${normalizedKey}`);
      return Surface;
    },
  });
};
